module.exports = __webpack_public_path__ + "img/logo_conectaa_branca.66b14c4b.svg";